import React from 'react';
import classnames from 'classnames';

export type Size = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface Props {
  className?: string;
  sm?: Size;
  md?: Size;
  lg?: Size;
  xl?: Size;
  right?: boolean;
  children?: React.ReactNode;
}

const columnSizeMap: Record<Size, string> = {
  0: 'col-span-0',
  1: 'col-span-1',
  2: 'col-span-2',
  3: 'col-span-3',
  4: 'col-span-4',
  5: 'col-span-5',
  6: 'col-span-6',
  7: 'col-span-7',
  8: 'col-span-8',
  9: 'col-span-9',
  10: 'col-span-10',
  11: 'col-span-11',
  12: 'col-span-12'
};

const Column: React.FC<Props> = ({ className, sm, md, lg, xl, right, children }) => {
  const classes = [
    sm !== undefined && columnSizeMap[sm],
    md !== undefined && `md:${columnSizeMap[md]}`,
    lg !== undefined && `lg:${columnSizeMap[lg]}`,
    xl !== undefined && `xl:${columnSizeMap[xl]}`,
    right && 'order-last'
  ].filter(Boolean);

  return <div className={classnames(classes, className)}>{children}</div>;
};

export default Column;
